"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseColumnFactoryFromJS = exports.DatabaseColumnFactory = void 0;
const immutable_1 = require("immutable");
exports.DatabaseColumnFactory = (0, immutable_1.Record)({
    name: null,
    type: 0 /* EParameterValueTypes.Unknown */,
    caption: null,
    columns: (0, immutable_1.List)()
});
const DatabaseColumnFactoryFromJS = function (data) {
    const columns = data.columns
        ? data.columns.map(i => (0, exports.DatabaseColumnFactoryFromJS)(i))
        : [];
    return (0, exports.DatabaseColumnFactory)(Object.assign(Object.assign({}, data), { columns: (0, immutable_1.List)(columns) }));
};
exports.DatabaseColumnFactoryFromJS = DatabaseColumnFactoryFromJS;
//# sourceMappingURL=IDatabaseColumn.js.map